
import { Avatar, Grid } from '@mui/material';
import './item-card.css';
import { Mail, Phone } from '@mui/icons-material';
import * as componentActions from 'src/redux/actions/users';
import { getById } from "src/services/user.service";
import { PapiroConsole } from 'src/utils/papiroConsole';
import { useDispatch } from 'react-redux';

const UserCard = (props) => {
    const { user, intl, history, lang, setNotification, setLoading } = props

    const dispatch = useDispatch()
    
    const goToUser = async () => {
        if (user && user.id) {
            setLoading(true)
            const response = await getById(user.id)
            if (response.success && response.data) {
                setLoading(false)
                dispatch(componentActions.addCurrent(response.data))
            }
            setLoading(false)
            history.push(`/${lang}/user-edit`)
        }
    }

    return (
        <Grid item container spacing={2} lg={12} md={12} sm={12} xs={12} className="cardItem" direction="row" alignItems="center" >
            <Grid item lg={3} md={3} sm={4} xs={4} className="requestinguser">
                <Grid container direction="column" alignItems="center">
                    <Grid item>
                        <Avatar alt={user.name}>
                            {user.name ? user.name.charAt(0) : ""}
                        </Avatar>
                    </Grid>
                    <Grid item>
                        <span>{user.name}</span>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item container lg={9} md={9} sm={8} xs={8} direction="row" alignItems="center" justifyContent="space-between" >
                <Grid item lg={3} md={3} sm={4} xs={4} style={{ display: "flex", alignItems: "center" }} onClick={goToUser}>
                    <span className="boldLine-two" style={{ cursor: "pointer" }}>
                        ID {user.id}
                    </span>
                </Grid>
                <Grid item lg={5} md={5} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                    <Mail style={{ marginRight: 4 }} />
                    <span style={{ wordBreak: "break-word" }}>{user.email}</span>
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                    {user.phone && (
                        <>
                            <Phone style={{ marginRight: 4 }} />
                            <span>{user.phone}</span>
                        </>
                    )}
                </Grid>
            </Grid>
        </Grid>
    )
}
export default UserCard
